import type { CompositorImageSource } from '../Views/CompositorView';

/** Stable asset IDs take precedence over expiring URLs; labels and layout are not content. */
export function imageSourceKey(source: CompositorImageSource): string {
  const { file } = source;
  return JSON.stringify({
    kind: source.kind,
    binding: source.binding,
    content: file.blobstore?.id ?? file.id ?? file.publicId ?? file.url,
    width: file.width,
    height: file.height,
  });
}
